import React from "react";

interface CurrentBalanceCardProps {
    balance: number;
}

const CurrentBalanceCard: React.FC<CurrentBalanceCardProps> = ({ balance }) => {
    return (
        <div className="bg-white rounded-2xl px-6 py-5 shadow-sm w-full flex flex-col items-center text-center">
            <div className="w-full flex items-center gap-2 text-xs font-semibold text-gray-500 uppercase tracking-wide">
                <span className="w-2 h-2 rounded-full bg-primary-red" />
                Current Balance
            </div>
            <p className="text-6xl font-bold text-gray-900 my-4 truncate">
                {balance.toLocaleString()}
                <span className="text-base font-medium text-gray-400 ml-1">pts</span>
            </p>
        </div>
    );
};

export default CurrentBalanceCard;
